import * as React from "react"
import * as portraitRowStyles from "./portrait-row.module.css"
import Img from "gatsby-image/withIEPolyfill"

const PortraitRow = (props) => {
    return (
        <div className="container-fluid no-gutters">
            <div className="row">
                <div className="col-xs-12 col-sm-4">
                    <div className={`rel`}>
                        <Img
                            fluid={props.image1Bg.childImageSharp.fluid}
                            objectFit="cover"
                        />
                        <div className={portraitRowStyles.bg}>
                            <Img 
                                fluid={props.image1.childImageSharp.fluid}
                                fadeIn={true}  
                                alt="" />
                        </div>
                        <div className={`${portraitRowStyles.drips} ${portraitRowStyles[props.dripTop]}`}>
                            {props.drip1}
                            {props.drip2}
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                    <div className={` rel`}>
                        <Img 
                            fluid={props.image2.childImageSharp.fluid}
                            fadeIn={true}  
                            alt="" />
                    </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                    <div className={` rel`}>
                        <Img 
                            fluid={props.image3.childImageSharp.fluid}
                            fadeIn={true}  
                            alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PortraitRow
